import { message, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchLessonSelection } from "../features/prof/profsSlice";

const { Option } = Select;
export default function LessonSelectionModal({ isOpen, classId, setIsLSMOpen }) {

    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookies, removeCookie] = useCookies();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [chosenLesson, setChosenLesson] = useState("");
    const [chosenModule, setChosenModule] = useState("");
    const [chosenModLessons, setChosenModLessons] = useState([]);


    const lessonSelectionSuccess = useSelector((state) => state.profs.lessonSelectionSuccess);

    const handleOk = () => {
        if (!chosenLesson) {
            message.warning("Vous devez sélectionner une leçon")
            return;
        }
        navigate(`/dashboard/classes/session/${classId}-${chosenLesson}`);
    }

    useEffect(() => {
        if (!chosenModule) return;

        const mod = lessonSelectionSuccess?.modules?.filter(
            (mod) => mod._id.toString() === chosenModule.toString()
        );
        
        setChosenModLessons(mod[0].lessons)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenModule]);

    useEffect(() => {
        dispatch(fetchLessonSelection(cookies));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Modal
            open={isOpen}
            okText="Lancer"
            cancelText="Annuler"
            onOk={handleOk}
            onCancel={() => setIsLSMOpen(false)}
        >
            <p>Choisir un module</p>
            <Select
                onChange={(e) => { setChosenModule(e) }}
                style={{ width: "90%", margin: "8px 16px" }}
                defaultValue={"Sélectionner un module"}
            >
                {lessonSelectionSuccess?.modules?.map((mod) =>
                    <Option value={mod._id} >Module {mod.seq}</Option>
                )}
            </Select>
            <p>Choisir une leçon</p>
            <Select
                onChange={(e) => { setChosenLesson(e) }}
                style={{ width: "90%", margin: "8px 16px" }}
                defaultValue={"Sélectionner une leçon"}
            >
                {chosenModLessons.map((lesson) =>
                    <Option value={lesson._id} >{lesson.name}</Option>
                )}
            </Select>
        </Modal>
    );
}

